
import React from 'react';
import { useForm } from '../../context/FormContext';
import FormProgressIndicator from './page-components/FormProgressIndicator';
import FormPageContent from './page-components/FormPageContent';

const FormContent: React.FC = () => {
  return (
    <div className="w-full">
      <FormProgressIndicator />
      <FormPageContent />
    </div>
  );
};

export default FormContent;
